import {debounce} from "./helper.js";
import {getFormBuilderForId} from "./popup-forms/getFormBuilderForId";

jQuery( document ).ready( function ( $ ) {

    if ( $( document ).width() <= 475 && ! $( 'body' ).hasClass( 'home' ) ) {
        $( '.green-btn' ).text( 'Trial' );
    }

    let zerif_frame = $( 'iframe.zerif_google_map' );
    let zerif_frameSrc = new Array();

    if ( zerif_frame.length ) {
        $.each( zerif_frame, function ( i, f ) {
            zerif_frameSrc[ i ] = $( f ).attr( 'src' );
            /*remove the src attribute so window will ignore these iframes*/
            $( f ).attr( 'src', '' );
        } );
    }

    function zerif_display_iframe_map() {
        if ( zerif_frame.length ) {
            $.each( zerif_frame, function ( a, x ) {
                /*put the src attribute value back*/
                $( x ).attr( 'src', zerif_frameSrc[ a ] );
            } );
        }
    }

    $( ".status" ).fadeOut();
    $( ".preloader" ).delay( 1000 ).fadeOut( "slow" );
    setTimeout( zerif_display_iframe_map, 500 );

    let link = window.location.href;
    let arr = link.split( '/' );

    if ( arr[ 3 ] == 'fr' || arr[ 3 ] == 'de' || arr[ 3 ] == 'es' ) {
        $( '.btn-primary' ).css( 'width', 'auto' );
        $( '.border-button' ).addClass( 'translateButton' );
        $( '.red-btn' ).addClass( 'translateButton' );
    }
    $( 'a.wpgridlightbox' ).click( function ( e ) {
        e.preventDefault();
        let href = '';
        if ( $( '#gridgallery-html5-lightbox' ).length != 0 ) {
            $( '.html5-nav-thumb' ).click( function () {
                setTimeout( function () {
                    href = $( '#gridgallery-html5-lightbox' ).find( '.html5-description a' ).attr( 'href' );
                    replaceHistory( href );
                    return true;
                }, 2000 );
            } );
        }
        href = $( this ).attr( 'data-href' );
        replaceHistory( href );
    } );
    let replaceHistory = function ( href ) {
        if ( ('replaceState' in window.history) && null !== window.history.replaceState ) {

            if ( typeof (href) == 'undefined' || href == '' ) {
                href = '#';
            }

            window.history.replaceState( null, null, href );
        }
    };

    if ( $( '.fadein-slider .slide-item' ).length > 1 ) {
        $( '.fadein-slider .slide-item:gt(0)' ).hide();
        setInterval( function () {
            $( '.fadein-slider :first-child' ).fadeOut( 2000 ).next( '.slide-item' ).fadeIn( 2000 ).end().appendTo( '.fadein-slider' );
        }, 10000 );
    }

    $( document ).scroll( function () {
        let scroll = $( document ).scrollTop();
        if ( scroll > 500 && ! $( '.recaptcha-added' ).length ) {
            $( 'body' ).append( '<div class="recaptcha-added"></div>' );
            let s = document.createElement( "script" );
            s.type = "text/javascript";
            s.src = "https://www.google.com/recaptcha/api.js";
            $( "head" ).append( s );
        }
    } );
    let thisOpen = false;
    $( '.contact-form .form-control' ).each( function () {
        if ( (typeof $( this ).val() != 'undefined') && ($( this ).val().length > 0) ) {
            thisOpen = true;
            $( '.zerif-g-recaptcha' ).css( 'display', 'block' ).delay( 1000 ).css( 'opacity', '1' );
            return false;
        }
    } );
    if ( thisOpen == false && (typeof $( '.contact-form textarea' ).val() != 'undefined') && ($( '.contact-form textarea' ).val().length > 0) ) {
        thisOpen = true;
        $( '.zerif-g-recaptcha' ).css( 'display', 'block' ).delay( 1000 ).css( 'opacity', '1' );
    }
    $( '.contact-form input, .contact-form textarea' ).focus( function () {
        if ( ! $( '.zerif-g-recaptcha' ).hasClass( 'recaptcha-display' ) ) {
            $( '.zerif-g-recaptcha' ).css( 'display', 'block' ).delay( 1000 ).css( 'opacity', '1' );
        }
    } );

    $( 'a[href="#open-modal-privacy"]' ).on( 'click', function() {

        let $modalBlock = $( '.privacy-policy-modal' );

        $modalBlock.addClass( 'modal-block' );

        setTimeout( function() {
            $modalBlock.addClass( 'showModal' );
        }, 100 );

        return false;

    } );

    $( '.privacy-policy-modal .close-modal , .privacy-policy-modal' ).on( 'click', function( e ) {

        let $target = $( e.target );

        if ( $target.hasClass( 'privacy-policy-modal' ) || $target.hasClass( 'close-modal' ) ) {

            let $modalBlock = $( '.privacy-policy-modal' );

            $modalBlock.removeClass( 'showModal' );

            setTimeout( function() {
                $modalBlock.removeClass( 'modal-block' );
            }, 400 );
        }

    } );

} );

/*** DROPDOWN FOR MOBILE MENU */
let callback_mobile_dropdown = function () {

    let navLi = jQuery( '#site-navigation li' );

    navLi.each( function () {
        if ( jQuery( this ).find( 'ul' ).length > 0 && ! jQuery( this ).hasClass( 'has_children' ) ) {
            jQuery( this ).addClass( 'has_children' );
            jQuery( this ).find( 'a' ).first().after( '<p class="dropdownmenu"></p>' );
        }
    } );
    jQuery( '.dropdownmenu' ).click( function () {
        if ( jQuery( this ).parent( 'li' ).hasClass( 'this-open' ) ) {
            jQuery( this ).parent( 'li' ).removeClass( 'this-open' );
        } else {
            jQuery( this ).parent( 'li' ).addClass( 'this-open' );
        }
    } );

    navLi.find( 'a' ).click( function () {
        jQuery( '.navbar-toggle' ).addClass( 'collapsed' );
        jQuery( '.collapse' ).removeClass( 'in' );
    } );

};
jQuery( document ).ready( callback_mobile_dropdown );

/* Bootstrap Fix */
if ( navigator.userAgent.match( /IEMobile\/10\.0/ ) ) {

    let msViewportStyle = document.createElement( 'style' )

    msViewportStyle.appendChild(
        document.createTextNode(
            '@-ms-viewport{width:auto!important}'
        )
    )

    document.querySelector( 'head' ).appendChild( msViewportStyle );

}

jQuery( document ).ready( function () {

    /* PARALLAX */
    let jQuerywindow = jQuery( window );

    jQuery( 'div[data-type="background"], header[data-type="background"], section[data-type="background"]' ).each( function () {

        let jQuerybgobj = jQuery( this );

        jQuery( window ).scroll( function () {

            let yPos = -(jQuerywindow.scrollTop() / jQuerybgobj.data( 'speed' ));

            let coords = '50% ' + yPos + 'px';

            jQuerybgobj.css( {

                backgroundPosition: coords

            } );

        } );

    } );

} );


/*=================================
===  SMOOTH SCROLL             ====
=================================== */

jQuery( document ).ready( function () {
    jQuery( '#site-navigation a[href*=\\#]:not([href=\\#]), header.header a[href*=\\#]:not([href=\\#])' ).bind( 'click', function () {
        let headerHeight;
        let hash = this.hash;
        let idName = hash.substring( 1 );    // get id name
        let alink = this;                 // this button pressed
        // check if there is a section that had same id as the button pressed
        if ( jQuery( 'section [id*=' + idName + ']' ).length > 0 && jQuery( window ).width() >= 751 ) {
            jQuery( '.current' ).removeClass( 'current' );
            jQuery( alink ).parent( 'li' ).addClass( 'current' );
        } else {
            jQuery( '.current' ).removeClass( 'current' );
        }
        if ( jQuery( window ).width() >= 751 ) {
            headerHeight = jQuery( '#main-nav' ).height();
        } else {
            headerHeight = 0;
        }
        if ( location.pathname.replace( /^\//, '' ) == this.pathname.replace( /^\//, '' ) && location.hostname == this.hostname ) {
            let target = jQuery( this.hash );
            target = target.length ? target : jQuery( '[name=' + this.hash.slice( 1 ) + ']' );
            if ( target.length ) {
                jQuery( 'html,body' ).animate( {
                    scrollTop: target.offset().top - headerHeight + 5
                }, 1200 );
                return false;
            }
        }
    } );
} );

jQuery( document ).ready( function () {
    let headerHeight;
    jQuery( '.current' ).removeClass( 'current' );
    jQuery( '#site-navigation a[href$="' + window.location.hash.replace( new RegExp( '\\?.*' ), '' ) + '"]' ).parent( 'li' ).addClass( 'current' );
    if ( jQuery( window ).width() >= 751 ) {
        headerHeight = jQuery( '#main-nav' ).height();
    } else {
        headerHeight = 0;
    }
    if ( location.pathname.replace( /^\//, '' ) == window.location.pathname.replace( /^\//, '' ) && location.hostname == window.location.hostname ) {
        let target = jQuery( window.location.hash.replace( new RegExp( '\\?.*' ), '' ) );
        if ( target.length ) {
            jQuery( 'html,body' ).animate( {
                scrollTop: target.offset().top - headerHeight + 5
            }, 1200 );
            return false;
        }
    }
} );

/* TOP NAVIGATION MENU SELECTED ITEMS */
function scrolled() {
    jQuery( this ).off( 'scroll' )[ 0 ].setTimeout( function () {
        if ( jQuery( window ).width() >= 751 ) {
            let zerif_scrollTop = jQuery( window ).scrollTop();       // cursor position
            let headerHeight = jQuery( '#main-nav' ).outerHeight();   // header height
            let isInOneSection = 'no';                              // used for checking if the cursor is in one section or not
            // for all sections check if the cursor is inside a section
            jQuery( "section" ).each( function () {
                let thisID = '#' + jQuery( this ).attr( 'id' );           // section id
                let zerif_offset = jQuery( this ).offset().top;         // distance between top and our section
                let thisHeight = jQuery( this ).outerHeight();         // section height
                let thisBegin = zerif_offset - headerHeight;                      // where the section begins
                let thisEnd = zerif_offset + thisHeight - headerHeight;         // where the section ends
                // if position of the cursor is inside of the this section
                if ( zerif_scrollTop >= thisBegin && zerif_scrollTop <= thisEnd ) {
                    isInOneSection = 'yes';
                    jQuery( '.current' ).removeClass( 'current' );
                    jQuery( '#site-navigation a[href$="' + thisID + '"]' ).parent( 'li' ).addClass( 'current' );    // find the menu button with the same ID section
                    return false;
                }
                if ( isInOneSection == 'no' ) {
                    jQuery( '.current' ).removeClass( 'current' );
                }
            } );
        }
        jQuery( this ).on( 'scroll', scrolled );
    }, 500 )
}

jQuery( window ).on( 'scroll', scrolled );


jQuery( window ).on( 'load', function () {

    /* SUBSCRIBE  */
    jQuery( "form :input" ).each( function ( index, elem ) {

        let eId = jQuery( elem ).attr( "class" );

        if ( (eId == "sib-email-area") || (eId == "sib-NAME-area") ) {

            let label = null;
            if ( eId && (label = jQuery( elem ).parents( "form" ).find( "label." + eId )).length == 1 ) {
                jQuery( elem ).attr( "placeholder", jQuery( label ).html() );
                jQuery( label ).remove();
            }
        }
    } );
} );


/* TOP NAVIGATION MENU SELECTED ITEMS */
jQuery( window ).scroll( function () {

    let zerif_scrollTop = jQuery( window ).scrollTop();
    let zerif_windowHeight = jQuery( window ).height();

    jQuery( "section" ).each( function () {

        let zerif_offset = jQuery( this ).offset();

        if ( zerif_scrollTop <= zerif_offset.top && (jQuery( this ).height() + zerif_offset.top) < (zerif_scrollTop + zerif_windowHeight) ) {

            jQuery( 'ul.nav > li a' ).each( function () {
                jQuery( this ).removeClass( 'nav-active' );
            } );

            let zerif_current_id_visible = jQuery( this ).attr( 'id' );

            jQuery( 'ul.nav > li a' ).each( function () {
                if ( jQuery( this ).attr( 'href' ).indexOf( zerif_current_id_visible ) >= 0 ) {
                    jQuery( 'ul.nav > li a' ).each( function () {
                        jQuery( this ).removeClass( 'nav-active' );
                    } );
                    jQuery( this ).addClass( 'nav-active' );
                }

            } );
        }

    } );

} );

/*** CENTERED MENU */
let callback_menu_align = function () {

    let headerWrap = jQuery( '.header' );
    let navWrap = jQuery( '#site-navigation' );
    let logoWrap = jQuery( '.responsive-logo' );
    let containerWrap = jQuery( '.container' );
    let classToAdd = 'menu-align-center';

    if ( headerWrap.hasClass( classToAdd ) ) {
        headerWrap.removeClass( classToAdd );
    }
    let logoWidth = logoWrap.outerWidth();
    let menuWidth = navWrap.outerWidth();
    let containerWidth = containerWrap.width();

    if ( menuWidth + logoWidth > containerWidth ) {
        headerWrap.addClass( classToAdd );
    } else {
        if ( headerWrap.hasClass( classToAdd ) ) {
            headerWrap.removeClass( classToAdd );
        }
    }
}
jQuery( window ).on( 'load', callback_menu_align );

jQuery( window ).resize( callback_menu_align );

let isMobile = {
    Android: function () {
        return navigator.userAgent.match( /Android/i );
    },
    BlackBerry: function () {
        return navigator.userAgent.match( /BlackBerry/i );
    },
    iOS: function () {
        return navigator.userAgent.match( /iPhone|iPad|iPod/i );
    },
    Opera: function () {
        return navigator.userAgent.match( /Opera Mini/i );
    },
    Windows: function () {
        return navigator.userAgent.match( /IEMobile/i );
    },
    any: function () {
        return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
    }
};

/* Rollover on mobile devices */
if ( isMobile.any() ) {

    /* Our team section */
    jQuery( '.team-member' ).on( 'click', function () {
        jQuery( '.team-member-open' ).removeClass( 'team-member-open' );
        jQuery( this ).addClass( 'team-member-open' );
        event.stopPropagation();
    } );
    jQuery( "html" ).click( function () {
        jQuery( '.team-member-open' ).removeClass( 'team-member-open' );
    } );

    /* Portfolio section */
    jQuery( document ).ready( function () {
        jQuery( '.cbp-rfgrid li' ).prepend( '<p class="cbp-rfgrid-tr"></p>' );
    } );
    jQuery( '.cbp-rfgrid li' ).on( 'click', function () {
        if ( ! jQuery( this ).hasClass( 'cbp-rfgrid-open' ) ) {
            jQuery( '.cbp-rfgrid-tr' ).css( 'display', 'block' );
            jQuery( '.cbp-rfgrid-open' ).removeClass( 'cbp-rfgrid-open' );

            jQuery( this ).addClass( 'cbp-rfgrid-open' );
            jQuery( this ).find( '.cbp-rfgrid-tr' ).css( 'display', 'none' );
            event.stopPropagation();
        }
    } );
    jQuery( "html" ).click( function () {
        jQuery( '.cbp-rfgrid-tr' ).css( 'display', 'block' );
        jQuery( '.cbp-rfgrid-open' ).removeClass( 'cbp-rfgrid-open' );
    } );

}

/* latest news */
jQuery( window ).on( 'load', function () {

    if ( jQuery( '#carousel-homepage-latestnews' ).length > 0 ) {
        if ( jQuery( '#carousel-homepage-latestnews div.item' ).length < 2 ) {
            jQuery( '#carousel-homepage-latestnews > a' ).css( 'display', 'none' );
        }
        let maxheight = 0;
        jQuery( '#carousel-homepage-latestnews div.item' ).each( function () {
            if ( jQuery( this ).height() > maxheight ) {
                maxheight = jQuery( this ).height();
            }
        } );
        jQuery( '#carousel-homepage-latestnews div.item' ).height( maxheight );
    }

} );


/* testimonial Masonry style */
let window_width_old;
let exist_class = false;
jQuery( document ).ready( function () {
    if ( jQuery( '.testimonial-masonry' ).length > 0 ) {
        exist_class = true;
        window_width_old = jQuery( '.container' ).outerWidth();
        if ( window_width_old < 970 ) {
            jQuery( '.testimonial-masonry' ).zerifgridpinterest( { columns: 1, selector: '.zerif_testim' } );
        } else {
            jQuery( '.testimonial-masonry' ).zerifgridpinterest( { columns: 3, selector: '.zerif_testim' } );
        }
    }
} );

jQuery( window ).resize( function () {
    if ( window_width_old != jQuery( '.container' ).outerWidth() && exist_class === true ) {
        window_width_old = jQuery( '.container' ).outerWidth();
        if ( window_width_old < 970 ) {
            jQuery( '.testimonial-masonry' ).zerifgridpinterest( { columns: 1, selector: '.zerif_testim' } );
        } else {
            jQuery( '.testimonial-masonry' ).zerifgridpinterest( { columns: 3, selector: '.zerif_testim' } );
        }
    }
} );


(function ( $, window, document, undefined ) {
    let defaults = {
        columns: 3,
        selector: 'div',
        excludeParentClass: '',
    };

    function ZerifGridPinterest( element, options ) {
        this.element = element;
        this.options = $.extend( {}, defaults, options );
        this.defaults = defaults;
        this.init();
    }

    ZerifGridPinterest.prototype.init = function () {
        let self = this,
            $container = jQuery( this.element );
        $select_options = jQuery( this.element ).children();
        self.make_magic( $container, $select_options );
    };
    ZerifGridPinterest.prototype.make_magic = function ( container ) {
        let self = this;
        $container = jQuery( container ),
            columns_height = [],
            prefix = 'zerif',
            unique_class = prefix + '_grid_' + self.make_unique();
        local_class = prefix + '_grid';
        let classname;
        let substr_index = this.element.className.indexOf( prefix + '_grid_' );
        if ( substr_index > -1 ) {
            classname = this.element.className.substr( 0, this.element.className.length - unique_class.length - local_class.length );
        } else {
            classname = this.element.className;
        }
        let my_id;
        if ( this.element.id == '' ) {
            my_id = prefix + '_id_' + self.make_unique();
        } else {
            my_id = this.element.id;
        }
        $container.after( '<div id="' + my_id + '" class="' + classname + ' ' + local_class + ' ' + unique_class + '"></div>' );
        let i;
        for ( i = 1; i <= this.options.columns; i++ ) {
            columns_height.push( 0 );
            let first_cols = '';
            let last_cols = '';
            if ( i % self.options.columns == 1 ) {
                first_cols = prefix + '_grid_first';
            }
            if ( i % self.options.columns == 0 ) {
                first_cols = prefix + '_grid_last';
            }
            jQuery( '.' + unique_class ).append( '<div class="' + prefix + '_grid_col_' + this.options.columns + ' ' + prefix + '_grid_column_' + i + ' ' + first_cols + ' ' + last_cols + '"></div>' );
        }
        if ( this.element.className.indexOf( local_class ) < 0 ) {
            $container.children( this.options.selector ).each( function ( index ) {
                let min = Math.min.apply( null, columns_height );
                let this_index = columns_height.indexOf( min ) + 1;
                jQuery( this ).attr( prefix + 'grid-attr', 'this-' + index ).appendTo( '.' + unique_class + ' .' + prefix + '_grid_column_' + this_index );
                columns_height[ this_index - 1 ] = jQuery( '.' + unique_class + ' .' + prefix + '_grid_column_' + this_index ).height();
            } );
        } else {
            let no_boxes = $container.find( this.options.selector ).length;
            for ( let i = 0; i < no_boxes; i++ ) {
                let min = Math.min.apply( null, columns_height );
                let this_index = columns_height.indexOf( min ) + 1;
                jQuery( '#' + this.element.id ).find( '[' + prefix + 'grid-attr="this-' + i + '"]' ).appendTo( '.' + unique_class + ' .' + prefix + '_grid_column_' + this_index );
                columns_height[ this_index - 1 ] = jQuery( '.' + unique_class + ' .' + prefix + '_grid_column_' + this_index ).height();
            }
        }
        $container.remove();
    }
    ZerifGridPinterest.prototype.make_unique = function () {
        let text = "";
        let possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        for ( let i = 0; i < 10; i++ )
            text += possible.charAt( Math.floor( Math.random() * possible.length ) );
        return text;
    }
    $.fn.zerifgridpinterest = function ( options ) {
        return this.each( function () {
            let value = '';
            if ( ! $.data( this, value ) ) {
                $.data( this, value, new ZerifGridPinterest( this, options ) );
            }
        } );
    }
    jQuery( '.toggle-answer' ).on( 'click', debounce(function () {
        jQuery( this ).closest( '.questions' ).toggleClass( 'open' );
    }, 100) );
})( jQuery );

jQuery( window ).on( 'load', zerif_parallax_effect );
jQuery( window ).resize( zerif_parallax_effect );

function zerif_parallax_effect() {

    let $ = jQuery;

    if ( jQuery( '#parallax_move' ).length > 0 ) {
        let scene = document.getElementById( 'parallax_move' );
        let window_width = jQuery( window ).outerWidth();
        jQuery( '#parallax_move' ).css( {
            'width': window_width + 120,
            'margin-left': -60,
            'margin-top': -60,
            'position': 'absolute',
        } );
        let h = jQuery( 'header#home' ).outerHeight();
        jQuery( '#parallax_move' ).children().each( function () {
            jQuery( this ).css( {
                'height': h + 100,
            } );
        } );
        if ( ! isMobile.any() ) {
            let parallax = new Parallax( scene );
        } else {
            jQuery( '#parallax_move' ).css( {
                'z-index': '0',
            } );
            jQuery( '#parallax_move .layer' ).css( {
                'position': 'absolute',
                'top': '0',
                'left': '0',
                'z-index': '1',
            } );
        }
    }
    jQuery( '.fixed-popup-close' ).on( 'click', function () {
        jQuery( '.fixed-popup.homepage' ).toggleClass( 'open-popup' );
    } );
    jQuery( '#wufoo-xuk1guo169lrm3 form ul' ).css( 'width', 250 );
    jQuery( '.form-block label.form-checkbox' ).on( 'click touchend', function () {

        if ( jQuery( this ).hasClass( 'check-label' ) ) {
            jQuery( this ).find( '.form-checkbox' ).removeAttr( 'checked' );
            jQuery( this ).removeClass( 'check-label' );
        } else {
            jQuery( this ).find( '.form-checkbox' ).attr( 'checked', 'checked' );
            jQuery( this ).addClass( 'check-label' );
        }
        let data_field = jQuery( this ).attr( 'data-field' );

        jQuery( '#Field' + data_field ).click();

    } );

    jQuery( document ).find( '.bx-wrapper .bx-viewport li .slider-text h3.entry-title' ).each( function () {
        let text = jQuery( this ).text();
        let res = text.indexOf( 'amp;' );
        if ( res > 0 ) {
            let new_text = text.replace( 'amp;', '' );
            jQuery( this ).text( new_text );
        }
    } );

}

jQuery( document ).ready( function ( $ ) {

    const
        $body = $( 'body' ),
        $window = $( window ),
        $document = $( document ),
        global = {
            loc: window.location
        };

    $document.on( 'submit', '.ajaxSendWufoo', function ( e ) {

        e.preventDefault();

        let btn = $( this ).find( 'input[type=submit]' );

        btn.addClass( 'disabled-btn' ).val( 'sending...' );

        let form = $( this ),
            category,
            formData = $( this ).serializeArray();

        if ( form.data( 'submitted' ) === true ) {
            e.preventDefault();
            return false;
        } else {
            form.data( 'submitted', true );
        }

        if ( $( 'html' ).data( 'page' ) === 8826 ) {
            formData.push( {
                name: 'success-text',
                value: 'Thank you for requesting a demo of GAMIFY. We will reach out to you as soon as we can.'
            } );

        }

        $.ajax( {
            url: '/wp-admin/admin-ajax.php',
            type: 'post',
            data: {
                action: 'ajax_send_intlock_wufoo_form',
                data: formData
            },
            success: function ( response ) {
                let form_name = form.find( '[name="name-form"]' ).val();

                if ( form.closest( '.modal-block.showModal' ).is( '.engage-popup' ) && form_name !== undefined ) {

                    if ( form_name === 'knrtodc0emy5vf' ) {
                        category = 'Submitted Engage Book A Demo';
                    } else if ( form_name === 'z1bq9ji00ysqmju' ) {
                        category = 'Get A Trial';
                    }

                    if ( typeof ga !== 'undefined' ) {
                        ga( 'send', 'event', { eventCategory: category, eventAction: 'submit' } );
                    }
                }

                form.closest( '.modal-block, [data-modal-block]' ).find( '.just-fill' ).remove();
                form.closest( '.modal-block, [data-modal-block]' ).find( '.after-form' ).remove();
                form.addClass( 'withAnswer' ).after( '<p>' + response + '</p>' );
            }
        } );

    } ).on( 'keyup', function ( e ) {

        let key = e.key;

        if ( key !== undefined && key.toLowerCase().indexOf( 'escape' ) !== -1 ) {

            $( '.contact-popup.form-block-popup' ).remove();

            intlock_modal( 'no-modal', e );

            closeDefaultModal();

        }

    } ).on( 'click', '.send-story', function ( e ) {

        e.preventDefault();

        let $this = $( this ),
            form_name = $this.closest( 'form' ).find( 'input[name=name-form]' ).val(),
            first_name = $this.closest( 'form' ).find( 'input[name=Field0]' ),
            last_name = $this.closest( 'form' ).find( 'input[name=Field1]' ),
            email = $this.closest( 'form' ).find( 'input[name=Field3]' ),
            url = '/wp-content/themes/zerif-pro/submitForms.php';

        if ( first_name.val().length <= 0 ) {
            first_name.addClass( 'error-field' );
        }

        if ( last_name.val().length <= 0 ) {
            last_name.addClass( 'error-field' );
        }

        if ( email.val().length <= 0 ) {
            email.addClass( 'error-field' );
        }

        let data = {
            'name-form': form_name,
            'first_name': first_name.val(),
            'last_name': last_name.val(),
            'email': email.val(),
        };

        $.post( url, data, function ( data ) {

            if ( data == 'none' ) {

                let parent = $( '.send-story' ).closest( '.modal-content' );

                parent.addClass( 'send-story-done' );
                parent.find( '.modal-form-header strong' ).text( 'Thank you for downloading' );
                parent.find( '.modal-form.form-block' ).append( '<p class="send-success">Your success story download is on its way</p>' );

            }
        } );

    } ).on( 'click', '.flip-container a', function () {

        let link = $( this ).attr( 'data-href' );

        if ( link ) {
            window.location.href = link;
        }

    } ).on( 'click', '.close-form', function () {
        $( '.contact-popup.form-block-popup' ).remove();
    } ).on( 'click', '.menu-search-button .shiftnav-target', function ( e ) {

        e.preventDefault();

        const
            $this = $( this ),
            block = $this.closest( '.shiftnav-inner' ),
            item = $this.closest( 'li' ),
            form = item.find( 'form' );

        if ( ! form.length ) {

            item.append( '' +
                '<form role="search" method="get" class="search-form" action="/">' +
                '<input type="search" value="" name="s">' +
                '<input type="submit" class="search-submit" value="Search">' +
                '</form>'
            );

            block.animate( {
                scrollTop: $( '.shiftnav-nav' ).outerHeight() + 50
            }, 2000 );

        } else {
            form.remove();
        }

    } ).on( 'click', '.blackrow a', function () {

        let $this = $( this ),
            row = $this.closest( '.blackrow' ),
            index = $this.parents( 'table' ).find( '.blackrow' ).index( $this.parents( '.blackrow' ) );

        row.toggleClass( 'opened' );

        dspAll( index );

    } ).on( 'click', '.pe-indent a', function () {

        let $this = $( this );
        let $dspcont = $this.parents( ".pe-indent" ).find( ".dspcont" );
        if ( $dspcont.is( ":visible" ) ) {
            $dspcont.hide();
            $this.find( "img" ).attr( "src", "/wp-content/uploads/2015/10/nav-arrow.gif" )
        } else {
            $dspcont.show();
            $this.find( "img" ).attr( "src", "/wp-content/uploads/2015/10/nav-arrow-down.gif" )
        }
        return false;
    } );

    function tableIcons() {
        setTimeout( function() {
            if ( ! $( '.blackrow' ).length ) {
                return;
            }

            $( '.blackrow' ).each( function ( i, el ) {

                let $el = $( el ),
                    color = $el.css( 'background-color' );

                if ( color !== undefined && color != '' ) {
                    let $img = $el.find( 'a:first-child img' );

                    $img.attr( 'src', '' );
                    $img.removeAttr( 'data-src' );
                    $img.css( {
                        'background-color': color,
                        'display': 'block'
                    } );
                }

            } );
        }, 1000 );
    }

    $( '.form-radio' ).on( 'click touchend', function () {

        let $this = $( this );

        if ( ! $this.is( '.check-label' ) ) {

            let check = $this.attr( 'data-check' );

            $( '.form-radio[data-check=' + check + ']' ).removeClass( 'check-label' );
            $this.addClass( 'check-label' );

        }

    } );

    let parseQueryString = function () {

        let str = window.location.search,
            objURL = {};

        str.replace(
            new RegExp( "([^?=&]+)(=([^&]*))?", "g" ),
            function ( $0, $1, $2, $3 ) {
                objURL[ $1 ] = $3;
            }
        );

        return objURL;

    };

    let params = parseQueryString();

    if ( params[ "tab" ] != undefined && params[ "tab" ] == 'social' ) {

        let $this = $( this );

        $( '.wonderplugin-gridgallery-tag-selected' ).each( function () {
            $this.click();
        } );

        $( '.wonderplugin-gridgallery-tag' ).each( function () {

            let slug = $this.attr( 'data-slug' );

            if ( slug == 'SocialPlatforms' ) {
                $this.click();
            }

        } );

    }

    $( '.demo' ).hover( function () {
        $( '.request-demo span' ).addClass( 'hoverSpan' );
    } );

    $( '.request-demo span a' ).on( 'mouseout', function () {
        $( '.request-demo span' ).removeClass( 'hoverSpan' );
    } );

    $( '.mobile-logo-img' ).on( 'click', function () {
        window.location.href = "/";
    } );

    function movedTrialItemsInMenu() {

        let item = $( '.trial-menu-items' );

        item.insertBefore( '.menu-item-3086' );

    }

    if ( $( '.permahide' ).length ) {

        setTimeout( function () {
            $( '.permahide' ).show();
        }, 1000 );

    }

    if ( window.location.href.indexOf( 'thank-you' ) >= 0 ) {
        $( '.customCall' ).remove();
    }

    if ( $body.is( '.page-id-7875' ) ) {

        $( 'html, body' ).attr( 'style', 'height: 100%; overflow: hidden;' );
        $( '.engage-landing-popup[data-hash=knrtodc0emy5vf]' ).click();

        $( '.close-modal' ).on( 'click', function () {
            $( 'html, body' ).attr( 'style', '' );
        } );

    }

    $( 'a.btn.btn-primary:not(.simple-button), .demo, .bottom-links a.left-link, a.contact-popup, .popupDemo' ).removeAttr( 'href' );

    $( '.contact-popup' ).on( 'click', function ( e ) {

        e.preventDefault();

        $body.append( '' +
            '<div class="contact-popup form-block-popup">' +
            '<div class="form-container">' +
            '</div>' +
            '</div>'
        );

        $( '.form-container' ).load( '/company/contactus/ #main .form-block' );

    } );

    $document.on( "click", ".form-block.contact-form i.close-modal", function () {
        $( ".contact-popup.form-block-popup" ).remove();
    } );

    let timer = false;

    function startTimer() {

        let my_timer = document.getElementById( "seconds" ),
            time = my_timer.innerHTML,
            after_click_download = jQuery( '.after-click-download' );

        if ( time == 0 ) {
            after_click_download.addClass( 'show-link' );
            after_click_download.find( 'a' ).attr( 'href', zerif.filePath );

        } else {
            time--;
        }

        document.getElementById( "seconds" ).innerHTML = time;

        timer = setTimeout( startTimer, 1000 );

    }

    $( '.download-file' ).on( 'click', function () {

        const timerTag = document.getElementById( "seconds" );

        if (timerTag === null) {
            return;
        }

        timerTag.innerHTML = 30;

        if ( timer ) {
            clearTimeout( timer );
        }

        startTimer();

        $( '.after-click-download' ).show();

    } );

    $( '.ajaxSend' ).on( 'submit', function ( e ) {

        e.preventDefault();

        let btn = $( this ).find( 'input[type=submit]' ),
            form = $( this );

        btn.addClass( 'disabled-btn' ).val( 'sending...' );

        if ( form.data( 'submitted' ) === true ) {
            e.preventDefault();
            return false;

        } else {
            form.data( 'submitted', true );
        }

        $.ajax( {
            url: '/wp-admin/admin-ajax.php',
            type: 'post',
            data: {
                action: 'send_form_with_ajax',
                data: $( this ).serializeArray()
            },
            success: function ( response ) {

                if ( response == 'open-popup' ) {

                    let modal = $( '.modal-block' );

                    btn.removeClass( 'disabled-btn' ).val( 'submit' );
                    modal.addClass( 'showModal formPopUp' ).find( '.modal-form-header *, .modal-form.form-block form, .modal-form.form-block .after-form' ).hide();
                    modal.find( '.close-modal' ).show();

                    if ( $body.is( '.page-id-7879' ) ) {
                        modal.find( '.modal-form-header' ).append( '<p class="popup-content" style="padding: 0 20px;">Thank you for submitting your meeting request! We\'ll reach out to you as soon as we can</p>' );
                        modal.find( '.modal-form.form-block' ).append( '<p class="popup-content"><a href="/" class="a btn btn-primary custom-button green-btn">Return to Site</a><a href="/downloads/sharepoint-office365-analytics/cardiolog-analytics-demo/" class="btn btn-primary custom-button purple-btn">Get Free Demo</a></p>' );
                    } else {
                        modal.find( '.modal-form-header' ).append( '<p class="popup-content" style="padding: 0 20px;">Thank you for submitting your opportunity! We\'ll reach out to you as soon as we can.</p>' );
                        modal.find( '.modal-form.form-block' ).append( '<p class="popup-content"><a href="/" class="a btn btn-primary custom-button green-btn">Return to Site</a><a href="/partners/become-a-partner/" class="btn btn-primary custom-button purple-btn">Discover Partner Benefits</a></p>' );
                    }
                } else {
                    window.location.href = response;
                }
            }
        } );

    } );

    $( '.open-custom-link' ).on( 'click', function () {
        window.location.href = '/aboutus/testimonials-and-success-stories/hines/';
    } );

    $( '.wufooAjaxSend' ).on( 'submit', function ( e ) {

        e.preventDefault();

        let form = $( this ),
            btn = form.find( 'input[type=submit]' ),
            modal = $( '.wufooModal' );

        if ( form.data( 'submitted' ) === true ) {
            e.preventDefault();
            return false;
        } else {
            form.data( 'submitted', true );
        }

        btn.addClass( 'disabled-btn' );

        $.ajax( {
            url: '/wp-admin/admin-ajax.php',
            type: 'post',
            data: {
                action: 'send_wufoo_form_with_ajax',
                data: $( this ).serializeArray()
            },
            success: function ( response ) {

                let result = $.parseJSON( response );

                if ( result[ 'success' ] ) {

                    if ( result[ 'success' ][ 'action' ] == 'openPopup' ) {

                        modal.addClass( 'showModal' );
                        modal.find( '.modal-form-header .popup-content' ).text( result[ 'success' ][ 'textHeader' ] );

                    }

                    if ( result[ 'success' ][ 'link' ] ) {

                        modal.find( '.second-btn' ).show().attr( 'href', result[ 'success' ][ 'link' ] ).text( result[ 'success' ][ 'linkText' ] );

                    }
                }
            }
        } );

    } );

    $( '.close-modal' ).on( 'click', function () {

        let modal = $( this ).closest( '.modal-block, [data-modal-block]' ),
            form = modal.find( 'form' ),
            return_data = form.find( '[old-name]' );

        modal.addClass( 'removing-modal' );

        if ( form.is( '.need-remove' ) ) {

            form.removeClass( 'need-remove ajaxSendWufoo' );

            if ( return_data ) {

                return_data.each( function ( i, el ) {

                    $( el ).attr( 'name', $( el ).attr( 'old-name' ) ).removeAttr( 'old-name' );
                    $( el ).attr( 'placeholder', $( el ).attr( 'old-placeholder' ) ).removeAttr( 'old-placeholder' );

                } );

            }

        }

        setTimeout( function () {

            modal.removeClass( 'showModal removing-modal formPopUp' ).find( '.modal-form-header *, .modal-form.form-block form, .modal-form.form-block .after-form' ).show();
            modal.find( '.popup-content' ).remove();

            $( '.ajaxSend' ).data( 'submitted', false ).find( 'input[type=submit]' ).attr( 'disabled', false );

        }, 600 );

    } );

    function modalForm() {

        $( 'a.btn.btn-primary:not(.simple-button), .demo, .bottom-links a.left-link, .popupDemo, .story-download, .engage-landing-popup' ).on( 'click', function ( e ) {
            e.preventDefault();

            let modal = this.hasAttribute('data-engage-link') ? $( '[data-modal-block="engage"]' ) : $( '.modal-block' ),
                form = modal.find( 'form' ),
                call_modal = $( this );


            if (this.dataset.formPopupId) {
                const formBuilder = getFormBuilderForId(this.dataset.formPopupId, this)
                if (formBuilder) {
                    return formBuilder.build({
                        container: modal.get(0)
                    })
                }
            }

            /**
             * @deprecated Use getFormBuilderForId instead
             */
            if ( call_modal.attr( 'data-form' ) ) {

                let get_modal = $( '.modal-block[data-form=' + call_modal.attr( 'data-form' ) + ']' );

                if ( get_modal.length ) {
                    modal = get_modal;
                }

            }

            let title = $( '.modal-form-header:not( .privacy-policy-modal-header ) strong' ),
                text = $( '.modal-text' ),
                country = $( '.country-input' ),
                page_ID = $( 'input[name=page_ID]' ).val(),
                parent_page_ID = $( 'input[name=parent_page_ID]' ).val(),
                action = call_modal.attr( 'data-action' );

            const formName = modal.find('form input[name=name-form]').clone();

            modal.find( 'form input[name=name-form], form input[name=form-redirect]' ).remove();
            modal.removeClass( 'saas-popup' );

            if ( action ) {
                modal.find( 'input[type=submit]' ).val( action );
            }

            if ( call_modal.is( '.green-btn' ) && !call_modal.is( '[data-engage-link]' ) ) {

                modal.find( 'form' ).attr( 'action', '/wp-content/themes/zerif-pro/submitClTrial.php' );
                title.text( 'Activate Your Free On-Prem Analytics Trial Now!' );
                text.text( 'Install our free trial in minutes.' );

                if ( page_ID == 2375 || parent_page_ID == 2375 || page_ID == 5551 || page_ID == 5548 || call_modal.is( '.saas-trial' ) ) {

                    modal.addClass( 'saas-popup' );
                    modal_action( modal, '/wp-content/plugins/wufoo-forms/submit/forms.php', 'saas-analytics-trial', title, 'Submit your SaaS Trial Request Now!', text, 'Enter your details for a CardioLog Analytics SaaS Trial.' );

                } else if ( call_modal.is( '.smb-trial' ) ) {

                    modal_action( modal, '/wp-content/themes/zerif-pro/submitForms.php', 'smb-trial', title, '', text, '' );

                } else if ( call_modal.is( '.engage-modal' ) ) {

                    modal_action( modal, '/wp-content/plugins/wufoo-forms/submit/forms.php', 'cardiolog-engage', title, 'Book a Demo', text, 'Please leave your contact information and we will contact you shortly.' );

                } else if ( call_modal.is( '.gamify-modal' ) ) {

                    form.addClass( 'ajaxSendWufoo need-remove' );

                    let target_input = form.find( '[name="Field1"]' );

                    if ( target_input ) {

                        target_input.attr( { // form adaptation to a parent form /products/sharepoint-office365-analytics/sharepoint-gamification/demo/#gamify_demo
                            'old-name': target_input.attr( 'name' ),
                            'old-placeholder': target_input.attr( 'placeholder' ),
                            'name': 'Field4',
                            'placeholder': 'Company*'
                        } );

                    }

                    modal_action( modal, '', 'zy2166q0lexyt6', title, 'Schedule a Demo Now', text, 'Drive adoption in Sharepoint & Microsoft 365 with Gamification Analytics.' );

                }

                country.attr( 'name', 'Field6' );

                $( '.modal-text' ).removeClass( 'demoText' );

                if ( page_ID == 6499 ) {

                    modal.find( 'form' ).append( '<input type="hidden" value="smb-trial" name="name-form" />' );
                    text.text( 'For a free trial and a product demo, please fill in your details and a representative will be happy to contact you within 24 business hours.' ).addClass( 'demoText' );

                }

            } else if ( call_modal.is( '.story-download' ) ) {

                modal.find( '.modal-content' ).removeClass( 'send-story-done' );
                modal.find( '.send-success' ).remove();

                if ( call_modal.is( '.vta-pdf' ) ) {

                    modal.find( 'form' ).append( '<input type="hidden" value="download-valley-transit-authoritys-success-story" name="name-form" />' );
                    modal.find( 'form' ).attr( 'data-form-name', 'khad60u1m5pu09' );

                } else if ( call_modal.is( '.allergan-pdf' ) ) {

                    modal.find( 'form' ).append( '<input type="hidden" value="download-allergans-success-story" name="name-form" />' );
                    modal.find( 'form' ).attr( 'data-form-name', 'k1miuofl0y2lk1s' );

                } else if ( call_modal.is( '.nordson-pdf' ) ) {

                    modal.find( 'form' ).append( '<input type="hidden" value="download-nordsons-success-story" name="name-form" />' );
                    modal.find( 'form' ).attr( 'data-form-name', 'p1nz5pep1eso1u8' );

                }

                title.text( 'Download the Success Story Now!' );
                modal.find( 'form' ).attr( 'action', '/wp-content/themes/zerif-pro/submitForms.php' );
                modal.find( 'form input[name=Field8], form select' ).hide();
                modal.find( 'form input[type=submit]' ).addClass( 'send-story' );

            } else if ( call_modal.is( '.engage-landing-popup' ) ) {

                let url = call_modal.attr( 'data-url' );

                if ( url ) {
                    modal.find( '[data-show=show-copy] textarea' ).val( url );
                }

                modal.find( 'form' ).attr( 'action', '' ).addClass( 'ajaxSendWufoo' );

                if ( call_modal.attr( 'data-title' ) ) {
                    title.text( call_modal.attr( 'data-title' ) );
                } else {
                    title.text( 'Sign Up for CardioLog Engage Now!' );
                }

                text.remove();
                modal.find( 'input[name=Field1]' ).remove();
                modal.find( 'select' ).attr( 'name', 'Field6' );
                modal.addClass( 'engage-popup' ).find( 'form' ).append( '<input type="hidden" value="' + call_modal.attr( 'data-hash' ) + '" name="name-form" />' );
                modal.find( 'form' ).attr( 'data-form-name', call_modal.attr( 'data-hash' ) );

                modal.find( 'input[name=success-text]' ).remove();

                if ( call_modal.attr( 'data-success-text' ) ) {
                    modal.find( 'form' ).append( '<input type="hidden" value="' + call_modal.attr( 'data-success-text' ) + '" name="success-text" />' );
                }

                if ( call_modal.attr( 'data-head-text' ) ) {
                    title.text( call_modal.attr( 'data-head-text' ) );
                }
            } else if ( call_modal.is( '.engage-default-btn' ) || call_modal.is( '.default-btn' ) ) {
                modal.find( 'form' ).append( formName );
            } else {

                if ( page_ID == 2375 || parent_page_ID == 2375 || page_ID == 5551 || page_ID == 5548 || call_modal.is( '.saas' ) ) {

                    modal.find( 'form' ).attr( 'action', '/wp-content/themes/zerif-pro/submitForms.php' );
                    modal.find( 'form' ).append( '<input type="hidden" value="saas-analytics-demo" name="name-form" />' );

                    if ( call_modal.is( '.saas' ) ) {
                        modal.find( 'form' ).append( '<input type="hidden" value="/downloads/sharepoint-office365-analytics/saas-analytics-trial/thank-you/" name="form-redirect" />' );
                    }

                } else {

                    modal.find( 'form' ).attr( 'action', '/wp-content/themes/zerif-pro/submitPersonalDemo.php' );
                }

                country.attr( 'name', 'Field19' );
                title.text( 'Book Your Live Demo' );
                text.show();
                text.html( "Just fill out the form to schedule your own online demo.<br> No hassles, no catches." ).next().hide();

                $( '.modal-text' ).addClass( 'demoText' );

                if ( page_ID == 6499 ) {

                    modal.find( 'form' ).append( '<input type="hidden" value="smb-demo" name="name-form" />' );
                    text.text( 'For a free trial and a product demo, please fill in your details and a representative will be happy to contact you within 24 business hours.' );

                }

                if ( call_modal.is( '.saas' ) ) {

                    title.text( 'Subscribe to Your SaaS Analytics Trial Now!' );
                    text.hide();

                }
            }

            modal.find( 'form' ).attr( 'data-form-name', call_modal.attr( 'data-form' ) );
            modal.addClass( 'showModal' );

        } );

        $( '.close-popup' ).on( 'click', function () {
            closeDefaultModal();
        } );
    }

    function closeDefaultModal() {
        $( '.modal-block, [data-modal-block]' ).removeClass( 'showModal' );
    }

    function modal_action( modal, action, value, title, title_content, text, text_content ) {

        if ( title_content != '' && title.length ) {
            title.text( title_content );
        }

        if ( text_content != '' && text_content.length ) {
            text.text( text_content );
        }

        modal.find( 'form' ).attr( 'action', action );
        modal.find( 'form' ).append( '<input type="hidden" value="' + value + '" name="name-form" />' );

    }

    function callFormByGet() {

        if ( ! $( '#trial-form' ).length ) {
            return;
        }

        window.URLSearchParams = window.URLSearchParams || function (searchString) {
            var self = this;
            self.searchString = searchString;
            self.get = function (name) {
                var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(self.searchString);
                if (results == null) {
                    return null;
                }
                else {
                    return decodeURI(results[1]) || 0;
                }
            };
        };

        let get = global.loc.search,
            params = new URLSearchParams( get ),
            popup,
            btn;

        if ( ! get || ! params.get( 'popup' ) ) {
            return;
        }

        popup = params.get( 'popup' );

        btn = $( '#' + popup + '-form' );

        if ( btn.length ) {
            btn.trigger( 'click' );
        }

    }

    $( '#show-copy' ).on( 'click', function () {

        let btn = $( this ),
            text = 'Show url',
            el = btn.attr( 'id' ),
            show = $( '[data-show=' + el + ']' ),
            input = show.find( 'textarea' ),
            modal = btn.closest( '.modal-content' );

        show.toggleClass( el );
        modal.toggleClass( el );

        if ( show.is( '.show-copy' ) ) {

            text = 'Hide url';

            input.select();

        }

        btn.text( text );

    } );

    $( '.call-modal' ).on( 'click', function ( e ) {

        let modal_name = $( this ).attr( 'href' ) || $( this ).find( 'a' ).attr( 'href' );

        if ( modal_name === undefined || modal_name.indexOf( '#' ) !== 0 || ! $( modal_name ).length ) {
            return;
        }

        intlock_modal( modal_name, e );

    } );

    $document.on( 'mousedown', function ( e ) {

        if ( ! $( '.modals-container.show-modal .modal-content.show-modal' ).length ) {
            return;
        }

        let target = $( e.target );

        if (
            target.is( '.modals-container .show-modal .hide-modal' ) ||
            (
                ! target.is( '.iti__country-list *' ) &&
                ! target.is( '.call-modal' ) &&
                ! target.is( '.modals-container .show-modal' ) &&
                ! target.is( '.modals-container .show-modal *' )
            )
        ) {
            intlock_modal( 'no-modal', e );
        }

    } );

    function intlock_modal( modal_name, e ) {

        let modal,
            s = 'show-modal',
            container = $( '.modals-container' );

        if ( modal_name === 'no-modal' ) {

            if ( e.which === 3 ) {
                return;
            }

            container.removeClass( s );
            container.find( '.' + s ).removeClass( s );


        } else {

            e.preventDefault();

            modal = $( modal_name );

            modal.toggleClass( s );
            container.toggleClass( s );

        }

    }

    function triggerPdfFile() {

        // used here /partners/partner-benefits/smb/benefits/
        if ( global.loc.pathname.indexOf( 'partners/partner-benefits/smb/benefits' ) < 0 || ! $( '.trigger-pdf' ).length ) {
            return;
        }

        let href = $( '.trigger-pdf' ).attr( 'href' );

        if ( href !== undefined && href !== '' ) {
            window.open( href, '_self' );
        }

    }

    function mainOverlay( event ) {

        if ( ! $( '#main_overlay' ).length ) {
            return;
        }

        let s = 'show-overlay',
            overlay = $( '#main_overlay' );

        if ( event === 'hide' ) {

            setTimeout( function () {
                overlay.removeClass( s );
            }, 1000 );

        } else if ( event === 'show' ) {
            overlay.addClass( s );

            setTimeout( function () {
                overlay.removeClass();
            }, 6000 );
        }

    }

    function triggerMediaPopup() {

        let hash = window.location.hash.replace( new RegExp( '\\?.*' ), '' );
        const item = $( '.wonderplugingridgallery a.wpgridlightbox[data-href="' + hash + '"]' );

        if ( ! item.length ) {
            return;
        }

        setTimeout( function() {
            $( item ).trigger( 'click' );
        }, 500 );

    }

    function apiCall() {

        // this functions uses on the /products/sharepoint-office365-analytics/editions/ page
        if ( window.location.pathname.indexOf( 'products/sharepoint-office365-analytics/editions' ) === -1 ) {
            return;
        }

        try {
            $.get( 'https://api.ipdata.co', function ( response ) {
                if ( response.continent_code !== undefined && response.continent_code === 'EU' ) {
                    window.location.href = '/products/sharepoint-office365-analytics/pricing/online/';
                } else {
                    $( '.start-price' ).removeClass( 'price-loader' );
                }

            }, 'jsonp' );
        } catch ( e ) {
            console.log( e );
        }
    }

    function dspAll( loc ) {
        let foc = document.getElementsByClassName( loc );
        if ( loc == "1" ) // if section is "Marketing Tools" then also hide/show its grey siblings
        {
            let greyRow = document.getElementsByClassName( "greyrow" );
            for ( let i = 0; i < greyRow.length; i++ ) {
                greyRow[ i ].parentNode.style.display = greyRow[ i ].parentNode.style.display == "" ? "none" : "";
            }
        }
        for ( let i = 0; i < foc.length; i++ ) {
            let focDisp = foc[ i ].parentNode.parentNode.parentNode.parentNode.style.display == "" ? "none" : "";
            foc[ i ].parentNode.parentNode.parentNode.parentNode.style.display = focDisp;
        }
    }

    function dsp( loc ) {
        let foc = loc.firstChild;
        foc = loc.firstChild.innerHTML ? loc.firstChild : loc.firstChild.nextSibling;
        foc.innerHTML = (foc.innerHTML.indexOf( "nav-arrow.gif" ) != -1) ? '<img border="0" src="/wp-content/uploads/2015/10/nav-arrow-down.gif">' : '<img border="0" src="/wp-content/uploads/2015/10//nav-arrow.gif">';
        foc = loc.parentNode.nextSibling.style ? loc.parentNode.nextSibling : loc.parentNode.nextSibling.nextSibling;
        foc.style.display = foc.style.display == 'block' ? 'none' : 'block';
    }

    if ( ! document.getElementById )
        document.write( '<style type="text/css"><!--\n' + '.dspcont{display:block;}\n' + '//--></style>' );

    function changeIt( loc ) { // toggle plus/minus for accordion item
        let theImg = loc.firstChild,
            x = theImg.src.split( "/" ),
            t = x.length - 1,
            y = x[ t ];

        let shape = y.split( "_" )[ 0 ];
        let color = y.split( "_" )[ 1 ];
        if ( shape == 'plus' ) {
            theImg.src = '/wp-content/uploads/2015/10/minus_' + color;
        }

        if ( shape == 'minus' ) {
            theImg.src = '/wp-content/uploads/2015/10/plus_' + color;
        }
    }

    function lazyLoadBgHref() {
        setTimeout( function() {
            const items = $( '[data-bg-image]' );

            if ( ! items.length ) {
                return;
            }

            items.each( function( i, el ) {
                let item = $( el ),
                    href = item.attr( 'data-bg-image' );

                item.attr( 'style', 'background-image: url(' + href + ')' );
            } );
        }, 3000 );
    }

    let generalEvents = {
        init: function () {
            this.elements();
            this.events();
        },
        elements: function () {
            this.triggerMainMailBtn = $( '.trigger-main-mail' );
        },
        events: function () {
            $window
                .on( 'beforeunload', this.beforeWindowUnload.bind( this ) )
                .on( 'resize', this.windowResize.bind( this ) );
            this.triggerMainMailBtn.on( 'click', this.triggerMainMail.bind( this ) );
        },
        beforeWindowUnload: function () {
            mainOverlay( 'show' );
        },
        triggerMainMail: function ( e ) {
            e.preventDefault();

            const
                m1 = 'contactus',
                m2 = '@',
                m3 = 'intlock',
                m4 = '.c',
                m5 = 'om',
                m6 = 'ma' + 'ilto',
                href = m6 + ':' + m1 + m2 + m3 + m4 + m5;

            window.open( href, '_self' );
        },
        windowResize: function () {
            const width = $window.width();

            if ( width > 768 && $body.is( '.shiftnav-open' ) ) {
                $body.removeClass( 'shiftnav-open shiftnav-open-left' );
            }
        }
    };

    function initIntlTelInput() {
        if ($body.hasClass('page-id-6490') || $body.hasClass('page-id-2375') || $('[data-modal-block="engage"]').length > 0) {
            let selectors = [ '[name="Field8"]', 'input[name="phone"]'];

            if ($('[data-modal-block="engage"]').length > 0) {
                selectors = ['[data-modal-block="engage"] input[name="phone"], [data-modal-block="engage"] input[name="Field8"]']
            }

            selectors.forEach(selector => {

                document.querySelectorAll(selector).forEach(input => {
                    input.placeholder = '';
                    window.intlTelInput(input, {
                        initialCountry: "auto",
                        geoIpLookup: (callback) => {
                            fetch("https://ipapi.co/json")
                                .then(res => res.json())
                                .then(data => callback(data.country_code))
                                .catch(() => callback("us"));
                        },
                        utilsScript: "/wp-content/themes/zerif-pro/js/intlTelInput/utils.js"
                    });
                });

            });
        }
    }

    apiCall();
    modalForm();
    tableIcons();
    callFormByGet();
    lazyLoadBgHref();
    triggerMediaPopup();
    movedTrialItemsInMenu();
    mainOverlay( 'hide' );
    triggerPdfFile();
    dspAll( 1 );
    dspAll( 2 );
    dspAll( 3 );
    dspAll( 4 );
    dspAll( 5 );
    dspAll( 6 );
    dspAll( 7 );
    dspAll( 8 ); // super methods which were written by a previous super developer
    initIntlTelInput();
    generalEvents.init();

} );
